
(() => {
  const initArticle = (root) => {
    if (!root || root.dataset.jtArticleReady === 'true') return;
    root.dataset.jtArticleReady = 'true';

    const content = root.querySelector('[data-jtarticle-content]');
    const desktopToc = root.querySelector('[data-jtarticle-toc]');
    const desktopList = root.querySelector('[data-jtarticle-toc-list]');
    const mobileToc = root.querySelector('[data-jtarticle-mobile-toc]');
    const mobileList = root.querySelector('[data-jtarticle-mobile-list]');

    if (content) {
      content.querySelectorAll('table').forEach((table) => {
        if (table.parentElement?.classList.contains('jtarticle__table-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'jtarticle__table-wrap';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });

      const headings = Array.from(content.querySelectorAll('h2, h3'));
      const usedIds = new Set();

      const slugify = (text) => {
        const base = String(text || '')
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 80) || 'section';

        let id = base;
        let count = 2;
        while (usedIds.has(id) || document.getElementById(id)) {
          id = `${base}-${count}`;
          count += 1;
        }
        usedIds.add(id);
        return id;
      };

      const addTocLink = (heading, list) => {
        if (!list) return;
        const link = document.createElement('a');
        link.className = `jtarticle__toc-link jtarticle__toc-link--${heading.tagName.toLowerCase()}`;
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', (event) => {
          event.preventDefault();
          heading.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          history.replaceState(null, '', `#${heading.id}`);
        });
        list.appendChild(link);
      };

      headings.forEach((heading) => {
        if (!heading.id) heading.id = slugify(heading.textContent);
        else usedIds.add(heading.id);
        addTocLink(heading, desktopList);
        addTocLink(heading, mobileList);
      });

      if (!headings.length) {
        if (desktopToc) desktopToc.hidden = true;
        if (mobileToc) mobileToc.hidden = true;
      } else if ('IntersectionObserver' in window && desktopList) {
        const linksById = new Map(
          Array.from(desktopList.querySelectorAll('a')).map((link) => [link.getAttribute('href').slice(1), link])
        );

        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

          if (!visible) return;
          linksById.forEach((link) => link.classList.remove('is-active'));
          linksById.get(visible.target.id)?.classList.add('is-active');
        }, {
          rootMargin: '-20% 0px -65% 0px',
          threshold: [0, 1]
        });

        headings.forEach((heading) => observer.observe(heading));
      }
    }

    root.querySelectorAll('[data-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        const original = button.textContent.trim();
        try {
          await navigator.clipboard.writeText(window.location.href);
          button.textContent = button.dataset.copiedLabel || 'Copied';
          window.setTimeout(() => { button.textContent = original; }, 1800);
        } catch (e) {
          window.prompt('Copy this link:', window.location.href);
        }
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-jtarticle-root]').forEach(initArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
